import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Partner } from '../../models/partner';
import { PasswordParams } from '../../models/password-params';
import { Router } from '@angular/router';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { MatDialog } from '@angular/material/dialog';
import { PageAgbPopupComponent } from '../../../../components/page-agb-popup/page-agb-popup.component';
import { PagePrivacyPolicyPopupComponent } from '../../../../components/page-privacy-policy-popup/page-privacy-policy-popup.component';
import { retry } from 'rxjs/operators';
import { PartnerFieldsConfigurations } from '../../models/partner-fields-configuration';

@Component({
  selector: 'app-partner-registration',
  templateUrl: './partner-registration.component.html',
  styleUrls: ['./partner-registration.component.css']
})
export class PartnerRegistrationComponent implements OnInit {

  @Input()
  partner: Partner;

  @Input()
  showPassword: boolean;

  @Input()
  password: PasswordParams;

  @Input()
  showEmailAgree: boolean;

  @Input()
  showPhoneAgree: boolean;

  @Input()
  showMediaAgree: boolean;

  @Input()
  showAGBAgree: boolean;

  @Input()
  showOldPasswordConfirmation: boolean;

  @Input()
  showRepeatEmail: boolean;

  @Input()
  title: boolean;

  @Input()
  description: boolean;

  @Input()
  fieldsConfigurations: PartnerFieldsConfigurations;

  _dynamicAvailableRegistrationFields = [];


  @ViewChild('partnerForm', { static: true }) partnerForm;

  @Output() eventRegistrationDataValid: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventRegistrationDataInvalid: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventRegistrationDataDirty: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventRegistrationDataNotDirty: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  showLoginUrl: boolean;
  @Output() eventLogin: EventEmitter<any> = new EventEmitter<any>();

  _partnerFormIsValid = false;
  _partnerPasswordFormIsValid = false;

  minAge: number;
  showFullName = false;
  showAddress = false;
  showPhone = false;

  constructor(
    private router: Router,
    private shopSettingsService: ShopSettingsService,
    private dialog: MatDialog,
  ) {
    this.showRepeatEmail = true;
  }

  ngOnInit(): void {
    this.minAge = this.shopSettingsService.minimalAgeToSignWaiver;
    this.showFullName = this.shopSettingsService.showFullNameInRegistration;
    this.showAddress = this.shopSettingsService.showAddressInRegistration;
    this.showPhone = this.shopSettingsService.showPhoneInRegistration;
  }

  partnerFormValid(): void {
    this._partnerFormIsValid = true;
    this._sendValidationState();
  }

  partnerFormInvalid(): void {
    this._partnerFormIsValid = false;
    this._sendValidationState();
  }

  partnerFormDirty(): void {
    this.eventRegistrationDataDirty.emit();
  }

  partnerFormNotDirty(): void {
    this.eventRegistrationDataNotDirty.emit();
  }

  partnerPasswordFormValid(): void {
    this._partnerPasswordFormIsValid = true;
    this._sendValidationState();
  }

  partnerPasswordFormInvalid(): void {
    this._partnerPasswordFormIsValid = false;
    this._sendValidationState();
  }

  agbAgreeChanged(event: any): void {
    this._sendValidationState();
  }

  _sendValidationState(): void {
    const partnerPasswordFormIsValid = this._partnerPasswordFormIsValid || this.password?.isEmpty;
    const partnerPasswordValid = !this.showPassword || partnerPasswordFormIsValid;
    const agbValid = !this.showAGBAgree || this.partner.termsOfUseAndPrivacyAccepted;

    if (this._partnerFormIsValid && partnerPasswordValid && agbValid) {
      this.eventRegistrationDataValid.emit();
    } else {
      this.eventRegistrationDataInvalid.emit();
    }
  }

  onPrivacyPolicyClick(): void {
    this.router.navigateByUrl('privacy');
  }

  get easyMode(): boolean {
    return this.shopSettingsService.easyRegistration && !this.fieldsConfigurations;
  }

  get repeatPassword(): boolean {
    return this.shopSettingsService.shopSettings && (this.shopSettingsService.shopSettings.partnerCodeAuthorization || this.showOldPasswordConfirmation);
  }

  onLogin(): void {
    this.eventLogin.emit();
  }

  showAGB(): void {
    this.dialog.open(PageAgbPopupComponent, { height: '90%' });
  }

  showPrivacyPolicy(): void {
    this.dialog.open(PagePrivacyPolicyPopupComponent, { height: '90%' });
  }

  get isVuMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  isFieldAvailable(name: string): boolean {
    if (!this.fieldsConfigurations) {
      return true;
    }

    return this.fieldsConfigurations.isFieldAvailable(name);
  }

  get showGender(): boolean {
    return this.isFieldAvailable('gender');
  }

  get showZip(): boolean {
    return this.isFieldAvailable('zip');
  }
}
